import css from 'styled-jsx/css'

export const userSessionModalStyles = css`
  .user-session-modal-body {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0.5rem 1rem;
  }

  .user-session-modal-body .logo {
    width: 15rem;
    margin: 1rem auto;
    position: absolute;
    top: -6rem;
    left: 0;
    right: 0;
  }

  .user-session-modal-body.iad .logo {
    width: 100%;
    max-width: 5rem;
    margin: 1rem auto;
    position: absolute;
    top: -8rem;
  }

  @media screen and (max-width: 500px) {
    .user-session-modal-body {
      padding: 0;
    }
    .user-session-modal-body .logo {
      display: none;
    }
  }
`
